import PanelHeader from "./PanelHeader";
import Select from "../../../components/common/controls/Select";

interface Props {
  demoExampleData: any;
  selectedDemoExample: any;
  handleChange: (value: any) => void;
}
export default function ExampleDataSelector(props: Props){
  const { demoExampleData, selectedDemoExample, handleChange } = props;

  const HeaderComponent = () => {
    return <PanelHeader stepCount={1} title={"Your input data"} />;
  };

  const SelectionComponent = () => {
    return (
      <div className="flex items-center">
        <Select
          dataSource={demoExampleData}
          displayExpr="title"
          defaultValue={selectedDemoExample}
          placeholder="Please select an example here"
          className="how-it-works-select h-10 w-60"
          onValueChanged={({ value }: any) => {
            handleChange(value);
          }}
        />
      </div>
    );
  };

  return (
    <div className="bg-promWhite py-4 shadow-custom rounded">
      <div className="flex px-6 space-x-6">
        <HeaderComponent />
        <SelectionComponent />
      </div>
    </div>
  );
}
